<img
  src="assets/images/logos/logo.gif"
  [ngStyle]="{ width: widthInPixel + 'px', height: widthInPixel + 'px' }"
  data-test="logo-loader-img"
/>
